'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = processHistoryFormObject;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _formInput = require('../molecules/forms/formInput');

var _formInput2 = _interopRequireDefault(_formInput);

var _formDropdown = require('../molecules/forms/formDropdown');

var _formDropdown2 = _interopRequireDefault(_formDropdown);

var _formRadio = require('../molecules/forms/formRadio');

var _formRadio2 = _interopRequireDefault(_formRadio);

var _getRadioBool = require('./getRadioBool');

var _getRadioBool2 = _interopRequireDefault(_getRadioBool);

var _getDateTimeDefaultValue = require('./getDateTimeDefaultValue');

var _getDateTimeDefaultValue2 = _interopRequireDefault(_getDateTimeDefaultValue);

var _processBoolVariable = require('./processBoolVariable');

var _processBoolVariable2 = _interopRequireDefault(_processBoolVariable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function processHistoryFormObject(historyObj, messages, sectionName, getFormattedMessage, fieldPrefix, optionList) {
	var historyObjectForm = [];

	if (historyObj.reason) {
		historyObjectForm.push(_react2.default.createElement(_formDropdown2.default, {
			label: getFormattedMessage(_extends({}, messages[sectionName].reason)),
			selectedOption: historyObj.reason,
			value: historyObj.reasonDescription && historyObj.reasonDescription + ' (' + historyObj.reason + ')' || historyObj.reason,
			references: optionList,
			fieldName: fieldPrefix + '.reason',
			placeholder: '-',
			allowEdit: true,
			key: fieldPrefix + '.reason'
		}));
	}

	if (new Date(historyObj.eventDate).getTime() !== (0, _getDateTimeDefaultValue2.default)()) {
		historyObjectForm.push(_react2.default.createElement(_formInput2.default, {
			label: getFormattedMessage(_extends({}, messages[sectionName].eventDate)),
			value: historyObj.eventDate,
			allowEdit: false,
			fieldName: fieldPrefix + '.eventDate',
			key: fieldPrefix + '.eventDate'
		}));
	}

	if (new Date(historyObj.startDate).getTime() !== (0, _getDateTimeDefaultValue2.default)()) {
		historyObjectForm.push(_react2.default.createElement(_formInput2.default, {
			label: getFormattedMessage(_extends({}, messages[sectionName].startDate)),
			value: historyObj.startDate,
			allowEdit: false,
			fieldName: fieldPrefix + '.startDate',
			key: fieldPrefix + '.startDate'
		}));
	}

	if (new Date(historyObj.endDate).getTime() !== (0, _getDateTimeDefaultValue2.default)()) {
		historyObjectForm.push(_react2.default.createElement(_formInput2.default, {
			label: getFormattedMessage(_extends({}, messages[sectionName].endDate)),
			value: historyObj.endDate,
			allowEdit: false,
			fieldName: fieldPrefix + '.endDate',
			key: fieldPrefix + '.endDate'
		}));
	}

	historyObjectForm.push(_react2.default.createElement(_formRadio2.default, {
		label: getFormattedMessage(_extends({}, messages[sectionName].atFault)),
		value: (0, _processBoolVariable2.default)(historyObj.atFault),
		allowEdit: true,
		fieldName: fieldPrefix + '.atFault',
		references: (0, _getRadioBool2.default)(),
		key: fieldPrefix + '.atFault'
	}));

	return historyObjectForm;
}